import React from 'react';
import { useTranslation } from 'react-i18next';

export const LegalNoticeShort = () => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 p-4 my-4">
      <p className="text-sm text-amber-800">
        {t('legal.short', 
          "Cet outil donne une estimation à partir des informations disponibles. Certaines composantes dépendent de documents du propriétaire."
        )}
      </p>
    </div>
  );
};

export const LegalNoticeLong = () => {
  const { t } = useTranslation();
  
  return (
    <div className="brand-card-soft p-4 my-4">
      <h4 className="font-semibold text-gray-900 mb-2">
        {t('legal.title', 'Avertissement')}
      </h4>
      <p className="text-sm text-gray-800 mb-2">
        {t('legal.long1', 
          "Estimation basée sur les informations disponibles et des hypothèses expliquées."
        )}
      </p>
      <p className="text-sm text-gray-800">
        {t('legal.long2', 
          "Pour un désaccord, seul le Tribunal administratif du logement peut trancher."
        )}
      </p>
      <p className="text-sm text-gray-800 mt-2">
        {t('legal.long3',
          "Il s'agit d'une estimation et d'un outil pour vous aider dans vos négociations avec votre propriétaire et n'a aucune valeur légale."
        )}
      </p>
    </div>
  );
};

export const EstimationBadge = ({ label }) => {
  const { t } = useTranslation();
  
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
      {label || t('legal.estimation', 'ESTIMATION')}
    </span>
  );
};

export const MissingInfoWarning = ({ message }) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex items-start gap-2 bg-yellow-50 border border-yellow-200 rounded p-3 my-2">
      <span className="text-yellow-500">&#9888;</span>
      <p className="text-sm text-yellow-800">
        {message || t('legal.missingInfo', 'Information non disponible')}
      </p>
    </div>
  );
};
